export enum SportTrainerRoleEnum {
    Trainer = 0,
    DisciplineLeader = 12,
    Admin = 13,
}